import {Person} from '../../../../../models/api/person.model';
import {ProfessionGroup} from '../../../../../models/api/profession-group.model';
import {BaseRegistrationPolicyForm} from '../../../modules/shared/components/base-registration-edit.service';
import {PolicyChangesTypes} from '../../../../../state/policy-edit/policy-edit.state';
import {PersonalDataFormModel} from '../../../../shared/components/personal-data-form/services/personal-data-form.model';

export namespace PolicyEdit {
    export enum InsuredEventType {
        ADD = 'ADD',
        EDIT = 'EDIT',
        DELETE = 'DELETE',
        IMPORT = 'IMPORT',
    }

    export interface InsuredEvent {
        type: InsuredEventType;
        personData?: PersonalDataFormModel;
        index?: number;
        persons?: Person[];
    }

    export interface PolicyForm extends BaseRegistrationPolicyForm {
        periodEqualization?: boolean;
        insuredCount?: number;
        insureds?: Person[];
        variants?: VariantForm[];
        premium?: number;
    }

    export interface VariantForm {
        name: string;
        professionGroup?: ProfessionGroup;
        selected?: boolean;
        risks?: RiskForm[];
        paidExtensions?: PaidExtensionForm[];
    }

    export interface RiskForm {
        code?: string;
        name?: string;
        symbol?: string;
        selected?: boolean;
        insuredSum?: number;
        integralFranchise?: string | number;
        reductionFranchise?: string | number;
        isActive?: boolean;
    }

    export interface PaidExtensionForm {
        code?: string;
        selected?: boolean;
    }

    export interface ShowElements {
        variants?: boolean;
        insured?: boolean;
        pool?: boolean;
        premium?: boolean;
    }

    export interface ChangeNotification {
        changeType: PolicyChangesTypes | null;
        readonly changeLabel: string | null;
    }
}
